@if (!this.data.delete) {
  <h1 mat-dialog-title>Reeks updaten</h1>
}
@if (this.data.delete) {
  <h1 mat-dialog-title>Reeks verwijderen</h1>
}
<mat-dialog-content>
  @if (!this.data.delete) {
    <div>
      @if (this.data.planType === this.planType.Automatic) {
        <h3>Wil je alle toekomstige voorbereide ritten in deze reeks updaten?</h3>
      } @else {
        <h3>Wil je alle toekomstige ritten in deze reeks updaten?</h3>
      }
      Wanneer je alleen deze rit bewerkt, zal deze niet langer onderdeel zijn van de reeks.
    </div>
  }
  @if (this.data.delete) {
    <div>
      @if (this.data.planType === this.planType.Automatic) {
        <h3>Wil je alle toekomstige voorbereide ritten in deze reeks verwijderen?</h3>
        <p>Geplande ritten en restritten worden niet verwijderd.</p>
      } @else {
        <h3>Wil je alle toekomstige ritten in deze reeks verwijderen?</h3>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]>Annuleren</button>
  <button mat-button [mat-dialog-close]="false">Alleen deze rit</button>
  @if (!this.data.delete) {
    <button cdkFocusInitial mat-flat-button (click)="updateCopies()">Alles updaten</button>
  }
  @if (this.data.delete) {
    <button
      cdkFocusInitial
      mat-flat-button
      [class.spinner]="deleting()"
      [disabled]="deleting()"
      (click)="deleteCopies()"
    >
      Alles verwijderen
    </button>
  }
</mat-dialog-actions>
